import React from 'react';
import { Loadable } from 'shared/hocs/loadable';
import { Loader } from 'shared/ui/loader';


export const SurveyInteractiveGameLoadable = Loadable({
    loader: (): any => import('./SurveyInteractiveGame').then((res) => res.SurveyInteractiveGame),
    loading: <Loader/>,
});
